import { USER_COMPANY } from "Constants";

import axios from "../../../api";
import { DashFilters } from "../../../models/dashboard.filters";
import { GenericDataResponse } from "../../../models/shipment.count";
import env from "../../../util/env";

const { API_URL } = env;

// #region - Common Functions
export function LogicBGLoader(arrBGoptions: string | any[], rowIndexRefs: number) {
  // eslint-disable-next-line for-direction, no-plusplus
  for (let idx = 5; idx <= arrBGoptions.length; idx--) {
    if (rowIndexRefs % idx === 0) return arrBGoptions[idx - 1];
  }
}
// #endregion

// #region - Local Storage
export function getCompanyInfo() {
  const localInfo = localStorage.getItem(USER_COMPANY);

  return localInfo ? JSON.parse(localInfo) : undefined;
}

function getAuthInfo() {
  const authInfo = localStorage.getItem("user_token");

  return authInfo || undefined;
}

export function getCurrentUser() {
  const currentUser = localStorage.getItem("current_user");

  return currentUser ? JSON.parse(currentUser) : undefined;
}
// #endregion

// #region - Service Functions
export async function GetAllCounts(filterData: any, count: string) {
  const companyInfo = getCompanyInfo();
  const authInfo = getAuthInfo();

  const hasFilter = Boolean(filterData.date_from !== undefined && filterData.date_to !== undefined);

  const URL_W_PARAMS = `${API_URL}dashboard/${count}?company_id=${companyInfo.id}${
    hasFilter ? `&date_from=${filterData.date_from}&date_to=${filterData.date_to}` : ""
  }`;

  const headers = {
    "Content-Type": "application/json",
    Authorization: authInfo || "",
  };

  return axios.get(`${URL_W_PARAMS}`, { headers });
}

export async function GetShipments() {
  try {
    const authInfo = getAuthInfo();

    const URL_W_PARAMS = `${API_URL}shipments/count/containers/:all`;

    const headers = {
      "Content-Type": "application/json",
      Authorization: authInfo || "",
    };

    return await axios.get(`${URL_W_PARAMS}`, { headers });
  } catch (error) {
    // TODO: ?
  }
}

export async function GetTopStockPositions() {
  const companyInfo = getCompanyInfo();
  const authInfo = getAuthInfo();

  const URL_W_PARAMS = `${API_URL}dashboard/stock-position?company_id=${companyInfo.id}`;

  const headers = {
    "Content-Type": "application/json",
    Authorization: authInfo || "",
  };

  let result;

  await axios.get(`${URL_W_PARAMS}`, { headers }).then((response) => {
    result = response;
  });

  return result;
}

export async function GetTopIncomingPO() {
  const companyInfo = getCompanyInfo();
  const authInfo = getAuthInfo();

  const URL_W_PARAMS = `${API_URL}dashboard/incoming-po?company_id=${companyInfo.id}`;

  const headers = {
    "Content-Type": "application/json",
    Authorization: authInfo || "",
  };

  let result;

  await axios.get(`${URL_W_PARAMS}`, { headers }).then((response) => {
    result = response;
  });

  return result;
}

export async function GetTopOverdueDespatches() {
  const companyInfo = getCompanyInfo();
  const authInfo = getAuthInfo();

  const URL_W_PARAMS = `${API_URL}dashboard/overdue-despatches?company_id=${companyInfo.id}`;

  const headers = {
    "Content-Type": "application/json",
    Authorization: authInfo || "",
  };

  let result;

  await axios.get(`${URL_W_PARAMS}`, { headers }).then((response) => {
    result = response;
  });

  return result;
}

export async function GetTopOrdersToShip() {
  const companyInfo = getCompanyInfo();
  const authInfo = getAuthInfo();

  const URL_W_PARAMS = `${API_URL}dashboard/orders-to-ship?company_id=${companyInfo.id}`;

  const headers = {
    "Content-Type": "application/json",
    Authorization: authInfo || "",
  };

  let result;

  await axios.get(`${URL_W_PARAMS}`, { headers }).then((response) => {
    result = response;
  });

  return result;
}

export async function GetDespatchesMetrics() {
  const companyInfo = getCompanyInfo();
  const authInfo = getAuthInfo();

  const URL_W_PARAMS = `${API_URL}dashboard/despatches-counts?company_id=${companyInfo.id}`;

  const headers = {
    "Content-Type": "application/json",
    Authorization: authInfo || "",
  };

  let result;

  await axios.get(`${URL_W_PARAMS}`, { headers }).then((response) => {
    result = response;
  });

  return result;
}

export async function GetStockSummary(filterData: any) {
  const companyInfo = getCompanyInfo();
  const authInfo = getAuthInfo();

  const hasSKU = Boolean(filterData.sku.length > 0);

  const hasFilter =
    filterData.date_from !== undefined && filterData.date_to !== undefined
      ? `&date_from=${filterData.date_from}&date_to=${filterData.date_to}`
      : "";

  let URL_W_PARAMS = `${API_URL}dashboard/carton-info?company_id=${companyInfo.id}${hasFilter}`;

  if (hasSKU) {
    URL_W_PARAMS = `${URL_W_PARAMS}&sku=${filterData.sku}`;
  }
  const headers = {
    "Content-Type": "application/json",
    Authorization: authInfo || "",
  };

  let result;

  await axios.get(`${URL_W_PARAMS}`, { headers }).then((response) => {
    result = response;
  });

  return result;
}

// Func:: Generic API Call
export async function GetCountsGenericCall(
  filterData: DashFilters,
  serviceURL: string
): Promise<GenericDataResponse> {
  const companyInfo = getCompanyInfo();
  const authInfo = getAuthInfo();

  const hasFilter =
    filterData.dateFrom !== undefined && filterData.dateTo !== undefined
      ? `&date_from=${filterData.dateFrom}&date_to=${filterData.dateTo}`
      : "";

  const withDateType =
    filterData.dateFilterType !== undefined ? `&date_filter_type=${filterData.dateFilterType}` : "";

  const hasProjFilter =
    filterData.projectName !== undefined ? `&project_name=${filterData.projectName}` : "";

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const URL_W_PARAMS = `${API_URL}dashboard/${serviceURL}?company_id=${companyInfo.id}${hasFilter}${withDateType}${hasProjFilter}`;

  const headers = {
    "Content-Type": "application/json",
    Authorization: authInfo || "",
  };

  let result: GenericDataResponse = {
    data: undefined,
  };

  await axios.get(`${URL_W_PARAMS}`, { headers }).then((response) => {
    result = response;
  });

  return result;
}

// #endregion
